import { render, staticRenderFns } from "./HowTo.html?vue&type=template&id=06c92704&scoped=true&"
import script from "./HowTo.ts?vue&type=script&lang=ts&"
export * from "./HowTo.ts?vue&type=script&lang=ts&"
import style0 from "./HowTo.css?vue&type=style&index=0&id=06c92704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c92704",
  null
  
)

export default component.exports